import React from "react";
import "./GradientButton.css"; 

const GradientButton = ({ label, onClick,type,className }) => {
  return (
    <button
      className={`gradient-button ${className}`}
      onClick={onClick}
      type={type}
    >
      {label}
    </button>
  );
};

export default GradientButton;
